// `config` se importa directo y NO por el contenedor: `inversify-config` importa este modulo, asi
// que pedirselo cierra un ciclo. Es el mismo objeto en los dos casos, porque el contenedor lo
// registra con `toConstantValue(config)`.
import config from 'src/config/app-config';
import { QueryApiService } from '../../common/api-service';
import { BackgroundOperationType, InProgressJob, WorkStatus } from './types';

export class WorksApiService extends QueryApiService<any> {
  constructor() {
    super('Works');
    const baseUrl = config.baseUrl;
    this._apiBaseUrl = `${baseUrl}/api/v1/Works`;
    this._odataBaseUrl = `${baseUrl}/odata/v1/Works`;
  }

  public async getWorkStatus(jobId: string): Promise<{ jobId: string; status: WorkStatus }> {
    return await this.get<{ jobId: string; status: WorkStatus }>(`${encodeURIComponent(jobId)}/status`);
  }

  public async getWorkResult<T = any>(jobId: string): Promise<T> {
    return await this.get<T>(`${encodeURIComponent(jobId)}/result`);
  }

  public async getInProgressJobs<T extends BackgroundOperationType>(operationType: T): Promise<InProgressJob<T>[]> {
    return await this.get<InProgressJob<T>[]>('me/jobs/in-progress', { operationType });
  }
}
